<template>
  <div class="page-sidebar-wrapper">
    <div class="page-sidebar navbar-collapse collapse">
      <ul class="page-sidebar-menu page-sidebar-menu-hover-submenu sidebar-menu-ul">
        <li v-for="(item, key) in menu" :class="{'active': item.active && item.active.indexOf(route)!==-1}"
            v-bind:key="key">
          <router-link :to="{ name: item.name }">
            <i :class="item.icon"></i>
            <span class="title">{{ item.title }}</span>
            <span class="arrow" v-if="item.sub"></span>
          </router-link>
          <ul class="sub-menu" v-if="item.sub">
            <li v-for="sub_item in item.sub" v-bind:key="sub_item.name">
              <router-link :to="{ name: sub_item.name }">{{ sub_item.title }}</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    '$route' (to, from) {
      this.setCurrentMenu(to.name)
    }
  },
  methods: {
    setCurrentMenu (selected) {
      this.route = selected
      this.menu.forEach((item) => {
        if (item.name === selected) {
          this.current = item
        } else {
          if (item.sub && item.sub.length > 0) {
            item.sub.forEach((subItem) => {
              if (subItem.name === selected) {
                this.current = item
              } else {
                if (subItem.active && subItem.active.length > 0) {
                  subItem.active.forEach((subActiveItem) => {
                    if (subActiveItem === selected) {
                      this.current = item
                    }
                  })
                }
              }
            })
          }
        }
      })
    }
  },
  created () {
    this.setCurrentMenu(this.$route.name)
  },
  data () {
    return {
      route: null,
      current: null,
      active: null,
      menu: [
        {
          name: 'home',
          icon: 'glyphicon glyphicon-home',
          title: 'Home',
          active: ['home']
        },
        {
          name: 'users.listing',
          icon: 'fa fa-users',
          title: 'User Management',
          active: ['users.listing', 'users.display', 'users.form', 'users.upgrade', 'referral-codes',
            'referral-codes.edit', 'referral-codes.create', 'membership-payments', 'manage.hives', 'hives.create',
            'hive.credits', 'broadcast-notifications'],
          sub: [
            {
              title: 'Manage Users',
              name: 'users.listing'
            },
            {
              title: 'Create a user',
              name: 'users.form'
            },
            {
              title: 'Upgrade a user',
              name: 'users.upgrade'
            },
            {
              title: 'Referral Codes',
              name: 'referral-codes'
            },
            {
              title: 'Referrals for Good',
              name: 'admin.referral.referrals-for-good'
            },
            {
              title: 'Membership Payments',
              name: 'membership-payments'
            },
            {
              title: 'Manage Hives',
              name: 'hives.listing'
            },
            {
              title: 'Manage Team Accounts',
              name: 'admin.employee.account'
            },
            {
              title: 'Manage Additional Engagement',
              name: 'admin.additional.account'
            },
            {
              title: 'Broadcast Notifications',
              name: 'broadcast.notifications'
            }
            // ,
            // {
            //   title: 'Hive Credits',
            //   name: 'hive.credits'
            // }
          ]
        },
        {
          name: 'admin.giving.listing',
          icon: 'glyphicon glyphicon-heart',
          title: 'Giving Management',
          active: ['admin.impact.token', 'admin.giving.listing', 'admin.giving.create', 'admin.giving.automated.listing', 'admin.giving.recurring.listing', 'admin.impact.expired.tokens'],
          sub: [
            {
              title: 'Manage Impact Token',
              name: 'admin.impact.token'
            },
            {
              title: 'Manage Expired Tokens',
              name: 'admin.impact.expired.tokens'
            },
            {
              title: 'Manage Giving',
              name: 'admin.giving.listing'
            },
            {
              title: 'Create New Contribution',
              name: 'admin.giving.create'
            },
            // {
            //   title: 'Giving Credits',
            //   name: 'admin.giving.credits.listing'
            // },
            // {
            //   title: 'Automated Giving',
            //   name: 'admin.giving.automated.listing'
            // },
            {
              title: 'Recurring Giving',
              name: 'admin.giving.recurring.listing'
            },
            {
              title: 'Manage Remittance',
              name: 'admin.giving.remittance.create'
            }
          ]
        },
        {
          name: 'admin.giving.listing',
          icon: 'fa icon-custom-projects',
          title: 'WC & Projects',
          active: [],
          sub: [
            {
              title: 'Create WC User',
              name: 'admin.wcuuser.create'
            },
            {
              title: 'WC Management',
              name: 'admin.wcuuser.profiles'
            },
            {
              title: 'WC Project Management',
              name: 'admin.wcuuser.projects'
            },
            {
              title: 'Project Listing Condition',
              name: 'admin.wcuuser.display_conditions'
            },
            {
              title: 'WC Project Updates',
              name: 'admin.wcuuser.project.updates'
            },
            {
              title: 'WC Project Changelog',
              name: 'admin.wcuuser.project.changelog'
            }
          ]
        },
        {
          name: 'admin.giving.listing',
          icon: 'glyphicon glyphicon-bullhorn',
          title: 'Communicare',
          active: [],
          sub: [
            {
              title: 'Milestone Emails',
              name: 'admin.emails.list'
            },
            {
              title: 'Banners',
              name: 'admin.banners'
            },
            {
              title: 'Events',
              name: 'admin.events.listing'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.page-sidebar {
  width: 195px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Side.vue